import { cn } from '@/lib/utils';
import { Content } from '@/components/layout/Content';
import { PageFooterProps } from './types';
import { usePageShellContext } from '../../context';

const footerClassNames = {
  fixed: 'fixed inset-x-0 bottom-0 z-40 pb-[env(safe-area-inset-bottom)] min-[769px]:pb-0',
  static: ''
};

const PageFooter = (props: PageFooterProps) => {
  const {
    children,
    className,
    contentClassName
  } = props;

  const {
    contentVariant,
    footerMode
  } = usePageShellContext();

  return (
    <footer className={cn('w-full shrink-0 bg-surface', footerClassNames[footerMode], className)}>
      <Content
        className={contentClassName}
        variant={contentVariant}
      >
        {children}
      </Content>
    </footer>
  );
};

export default PageFooter;